import { decode as base64Decode } from 'base-64';

/**
 * Extract device ID from JWT token
 * @param {string} token - JWT token
 * @returns {string|null} - Device ID or null if extraction fails
 */
export const extractDeviceIdFromToken = (token) => {
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return null;
        
        const payload = parts[1];
        const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
        const decodedPayload = base64Decode(paddedPayload);
        const parsedPayload = JSON.parse(decodedPayload);

        const data = JSON.parse(parsedPayload?.data?.data || '{}');
        return data.device_id || parsedPayload.device_id || null;
    } catch (error) {
        console.error('Error extracting device ID from token:', error);
        return null;
    }
};
